<script lang="ts">
  import { IMAGE_SIZES, getCloudflareImageVariant } from '$lib/utils';
    import type { JsonValue } from '@prisma/client/runtime/library';
    import { writable } from 'svelte/store';

  export let src: string | JsonValue | undefined | null;
  export let alt: string = '';
  export let style: string = '';

  let srcset: string | undefined;
  const source = writable<string>('');

  $: if (src) {
    if (typeof src === 'string') {
      source.set(src);
    } else if (Array.isArray(src)) {
      source.set(src[0] as any);
    }
    srcset =
      $source
        ? IMAGE_SIZES.map(
            (variant) => `${getCloudflareImageVariant($source, variant)} ${variant}w`
          ).join(',')
        : '';
  }
</script>

{#if $source}
  <img
    src={getCloudflareImageVariant($source, IMAGE_SIZES[0])}
    class={$$props.class}
    alt={alt ?? ''}
    {srcset}
    {style}
  />
{:else}
  <img src="/assets/placeholder.jpeg" class={$$props.class} {alt} {style} />
{/if}
